/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const HistoryIcon = ({ width = 24, height = 24, hidden = false, title = 'History' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.21973,12.65674c-.12891,0-.25977-.0332-.37891-.10352l-3.2207-1.89502c-.22949-.13477-.37012-.38086-.37012-.64648v-5c0-.41406.33594-.75.75-.75s.75.33594.75.75v4.57129l2.85059,1.67725c.35742.20996.47656.66992.2666,1.02686-.13965.2373-.39062.36963-.64746.36963Z"
      fill="currentColor"
    />
    <path
      d="M10,1.25c-2.78918,0-5.39026,1.36719-7.02332,3.56567l-.24426-1.48462c-.06738-.40918-.46289-.68359-.8623-.61816-.4082.06738-.68555.45361-.61816.8623l.55371,3.36279c.06055.36719.37891.62793.73926.62793.04004,0,.08105-.00293.12207-.00977l3.36621-.55127c.40918-.06689.68555-.45264.61914-.86133-.06738-.4082-.44727-.68359-.86133-.61914l-1.68457.27588c1.34741-1.87939,3.54175-3.05029,5.89355-3.05029,3.99805,0,7.25,3.25244,7.25,7.25s-3.25195,7.25-7.25,7.25c-2.98047,0-5.62305-1.78662-6.73145-4.55225-.1543-.38477-.59082-.57178-.97559-.41699-.38477.1543-.57129.59082-.41699.97559,1.33887,3.3374,4.52734,5.49365,8.12402,5.49365,4.8252,0,8.75-3.92529,8.75-8.75S14.8252,1.25,10,1.25Z"
      fill="currentColor"
    />
  </svg>`;
};
